import { CollectError } from '../../config';

export default function reformatValue(e, replacePattern, replacement) {
  let regExpParts, pattern;
  try {
    regExpParts = /\/(.*)\/(.*)/.exec(replacePattern);
    pattern = new RegExp(regExpParts[1], regExpParts[2]);
    e.target.value = e.target.value.replace(pattern, replacement);
  } catch (e) {
    throw new CollectError('Invalid regExp pattern');
  }
}
